import { TabInterface } from './tab.interface';

export class NavInterface {
	tabs: TabInterface[] = [];

	selectTab(tab: TabInterface): void { }

	addTab(tab: TabInterface): void { }
}
